module.exports = __webpack_public_path__ + "5ad6cd242314d820a2386fa7345cd0dc.woff2";